// extracted by mini-css-extract-plugin
module.exports = {"image":"header_image__E_thM","container":"header_container__2Tm8f","text":"header_text__qJBIu"};